// extracted by mini-css-extract-plugin
module.exports = {"card":"jobPost_card__1y1p8","content":"jobPost_content__2BIPJ","field":"jobPost_field__11GQJ","spaced_container":"jobPost_spaced_container__3V6WC"};